package pl.mothdigital.neuronowi.pages.specialists

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.components.navigation.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.selectors.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.sections.cta.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*

@Page
@Composable
fun SpecialistsPage() {
    val context = rememberPageContext()

    PageLayout(
        title = StringResources.SPECIALISTS_PAGE_TITLE,
        contentAlignment = Alignment.TopStart,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            VerticalSpacer(78.px)
            SpecialistsHeaderSection()
            SpecialistsTeamSection()
            CTASection(context)
        }
    }
}

@Composable
fun SpecialistsHeaderSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 4.cssRem, leftRight = 6.percent)
            .backgroundColor(SiteTheme.green._50)
            .toAttrs()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center),
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH2 { Text("Nasz zespół specjalistów".fixPolishOrphans()) }
            AppP(color = SiteTheme.green._800) {
                Text("Poznaj dokładniej osoby, które wspierają naszych pacjentów na co dzień".fixPolishOrphans())
            }
        }
    }
}

val SpecialistCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(SiteTheme.white._900)
            .boxShadow(blurRadius = 4.px, color = rgba(0, 0, 0, 0.1))
            .borderRadius(1.cssRem)
            .transition(Transition.of("all", 0.3.s))
    }
    hover {
        Modifier
            .backgroundColor(SiteTheme.white._800)
            .boxShadow(blurRadius = 16.px, color = rgba(0, 0, 0, 0.15))
            .cursor(Cursor.Pointer)
    }
}

@Composable
fun SpecialistsTeamSection() {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .padding(topBottom = 3.cssRem, leftRight = 6.percent)
            .toAttrs()
    ) {
        Column(modifier = Modifier.fillMaxWidth().gap(2.cssRem)) {
            // Tutaj można dodać komponenty filtrowania i sortowania w przyszłości
            
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .flexWrap(FlexWrap.Wrap)
                    .gap(2.cssRem),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.Top
            ) {
                SpecialistCard(
                    avatar = ImageResources.avatarMagdalenaNowik.src,
                    name = StringResources.MAGDALENA_NOWIK,
                    role = "Neurologopeda kliniczny, logopeda ortognatyczny",
                    screen = Screen.MagdalenaNowik,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarZaklinaWykret.src,
                    name = StringResources.ZAKLINA_WYKRET,
                    role = StringResources.ZAKLINA_WYKRET_HEADER_SUBTITLE,
                    screen = Screen.ZaklinaWykret,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarEwaSofinska.src,
                    name = StringResources.EWA_SOFINSKA,
                    role = StringResources.EWA_SOFINSKA_ACADEMIC_TITLES,
                    screen = Screen.EwaSofinska,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarMartaDybalska.src,
                    name = StringResources.MARTA_DYBALSKA,
                    role = StringResources.MARTA_DYBALSKA_ACADEMIC_TITLES,
                    screen = Screen.MartaDybalska,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarRadoslawNitschke.src,
                    name = StringResources.RADOSLAW_NITSCHKE,
                    role = StringResources.RADOSLAW_NITSCHKE_ACADEMIC_TITLES,
                    screen = Screen.RadoslawNitschke,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarJuliaSiuta.src,
                    name = StringResources.JULIA_SIUTA,
                    role = StringResources.JULIA_SIUTA_ACADEMIC_TITLES,
                    screen = Screen.JuliaSiuta,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarPaulinaKonieczna.src,
                    name = StringResources.PAULINA_KONIECZNA,
                    role = StringResources.PAULINA_KONIECZNA_ACADEMIC_TITLES,
                    screen = Screen.PaulinaKonieczna,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarPatrycjaOchryniuk.src,
                    name = StringResources.PATRYCJA_OCHRYNIUK,
                    role = StringResources.PATRYCJA_OCHRYNIUK_ACADEMIC_TITLES,
                    screen = Screen.PatrycjaOchryniuk,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarAnnaPetrus.src,
                    name = StringResources.ANNA_PETRUS,
                    role = StringResources.ANNA_PETRUS_ACADEMIC_TITLES,
                    screen = Screen.AnnaPetrus,
                )
                SpecialistCard(
                    avatar = ImageResources.avatarMagdalenaBanach.src,
                    name = StringResources.MAGDALENA_BANACH,
                    role = StringResources.MAGDALENA_BANACH_ACADEMIC_TITLES,
                    screen = Screen.MagdalenaBanach,
                )
            }
        }
    }
}

@Composable
fun SpecialistCard(avatar: String, name: String, role: String, screen: Screen) {
    Link(
        path = screen.route,
        modifier = SpecialistCardStyle.toModifier()
            .width(300.px)
            .padding(1.cssRem)
            .tabIndex(0),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top,
        ) {
            Image(
                src = avatar,
                alt = name,
                modifier = Modifier
                    .width(250.px)
                    .height(auto)
                    .borderRadius(1.cssRem),
            )
            VerticalSpacer(24.px)
            AppH3(modifier = Modifier.textAlign(TextAlign.Center)) { Text(name.fixPolishOrphans()) }
            VerticalSpacer(6.px)
            AppP(modifier = Modifier.textAlign(TextAlign.Center).minHeight(48.px)) { Text(role.fixPolishOrphans()) }
        }
    }
}
